import api from './apiService';

/**
 * Client for the BE file-indexer endpoints.
 * Note: apiService's response interceptor unwraps the response so callers
 * receive `data` directly (see apiService.js:69-86).
 */

/**
 * Search TOC entries across every indexed file.
 * Returns `{ query, results: [{ fileKey, matches: TocEntry[] }] }`.
 */
export const searchToc = async (q, limit = 20) => {
  const params = new URLSearchParams({ q, limit: String(limit) }).toString();
  return api.get(`/file-indexer/search-toc?${params}`);
};

/**
 * Fetch the cached TOC + status for a single file.
 * Returns null on 404 — meaning the file has no index yet.
 */
export const getToc = async (fileKey) => {
  try {
    const params = new URLSearchParams({ fileKey }).toString();
    return await api.get(`/file-indexer/toc?${params}`);
  } catch (err) {
    if (err?.response?.status === 404) return null;
    throw err;
  }
};
